import React from "react";
import PropTypes from "prop-types";
import {
  DropdownIndicator,
  EmptyIndicatorSeparator as IndicatorSeparator,
  CountryOption as Option,
  CountrySingleValue as SingleValue
} from "../../helpers/select/components";
import { Select } from "../simple";
import countries from "../../assets/countries.json";

const customComponents = {
  DropdownIndicator,
  IndicatorSeparator,
  Option,
  SingleValue
};

export default function CountrySelect(props) {
  return (
    <Select
      label="Country"
      placeholder="Country"
      // options={props.countries.length ? props.countries : [countries]}
      options={props.countries.length ? props.countries : []}
      name="country"
      required
      components={customComponents}
      {...props}
      handleChange={props.handleChange}
      value={countries.find(({ value }) => value === props.value) || ""}
    />
  );
}

CountrySelect.propTypes = {
  handleChange: PropTypes.func.isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape({})),
  value: PropTypes.string
};

CountrySelect.defaultProps = {
  countries: [],
  value: ""
};
